import { render, staticRenderFns } from "./ShippingTemplate.vue?vue&type=template&id=66f2d5ca&scoped=true&"
import script from "./ShippingTemplate.vue?vue&type=script&lang=js&"
export * from "./ShippingTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66f2d5ca",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('66f2d5ca')) {
      api.createRecord('66f2d5ca', component.options)
    } else {
      api.reload('66f2d5ca', component.options)
    }
    module.hot.accept("./ShippingTemplate.vue?vue&type=template&id=66f2d5ca&scoped=true&", function () {
      api.rerender('66f2d5ca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Papers/pages/Paper/components/Templates/ShippingTemplate.vue"
export default component.exports